<!-- SIDEBAR -->
<div class="sidebar" [ngClass]="{ collapsed: isCollapsed }">
  <div class="flex flex-col items-center p-2">
    <div class="flex flex-col items-center">
      <img
        [src]="
          isCollapsed
            ? 'assets/img/logo-aduana.svg'
            : 'assets/img/logo-side.png'
        "
        alt="logo"
        [class]="isCollapsed ? 'p-4' : ''"
      />
      <p
        [hidden]="isCollapsed"
        class="font-semibold text-texto-blanco tracking-[-0.07px] text-sm"
      >
        SUBASTAS 360
      </p>
    </div>
  </div>

  <div class="sidebar-options gap-2">
    <a
      *ngFor="let option of filteredSidebarOptions"
      [routerLink]="option.route"
      class="px-[24px] py-[19px] hover:bg-primario-800"
      [class.active-option]="isOptionActive(option.label, option.route)"
    >
      <div
        [class]="
          isCollapsed ? 'flex flex-col items-center' : 'flex flex-row gap-4'
        "
      >
        <div class="icon-wrapper">
          <img [src]="option.iconPath" class="side-option-icon" />
        </div>
        <p
          [hidden]="isCollapsed"
          class="font-semibold text-texto-blanco text-base"
        >
          {{ option.label }}
        </p>
      </div>
    </a>
  </div>

  <p class="inner-divisor"></p>
  <div class="collapse-button">
    <div class="inner-icon" (click)="toggleSidebar()">
      <img src="assets/img/inner-sidebar-icon.png" class="inner-option-icon" />
    </div>
  </div>
</div>

<!-- MAIN CONTENT WRAPPER -->
<div class="main-wrapper" [ngClass]="{ 'sidebar-collapsed': isCollapsed }">
  <!-- HEADER -->
  <div class="header-wrapper">
    <div class="header" [ngClass]="{ 'sidebar-collapsed': isCollapsed }">
      <div class="header-content">
        <div class="header-frame">
          <!-- Notificaciones -->
          <app-notifications></app-notifications>
          <!-- /Notificaciones -->

          <p class="divisor"></p>

          <div class="flex items-center justify-center gap-4">
            <div>
              <p class="text-primario-base font-semibold">
                {{ (auth.currentUser$ | async)?.name || 'Usuario' }}
              </p>
              <p class="">{{ (auth.currentUser$ | async)?.role || '' }}</p>
            </div>
            <div class="flex items-center justify-center gap-3">
              <button class="text-primario-base underline" (click)="logout()">Salir</button>
              <img src="assets/img/Vector-Dropdown.png" alt="Dropdown" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- PAGE -->
  <div class="page-content" [ngClass]="{ 'sidebar-collapsed': isCollapsed }">
    <router-outlet></router-outlet>
  </div>

  <!-- FOOTER -->
  <div class="footer" [ngClass]="{ 'sidebar-collapsed': isCollapsed }">
    <p>Copyright © 2025 Dirección General de Aduanas</p>
  </div>
</div>
